import markItemsJunkNotJunkBasedOnItemIds from './helpers/markItemsJunkNotJunkBasedOnItemIds';
import createItemContextsForDeleteStoreUpdate from '../helpers/createItemContextsForDeleteStoreUpdate';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import mailStore from 'owa-mail-store/lib/store/Store';
import doesFolderIdEqualName from 'owa-session-store/lib/utils/doesFolderIdEqualName';
import { select } from 'satcheljs/lib/legacy';
/**
 * Mark item as junk/not junk
 * @param itemIds the specified item Ids to be marked as junk
 * @param actionSource the source that initiated the action
 * @param state the MarkItemJunkNotJunkFromReadingPaneState which contains the original table view
 */
export default select({
    item: function (itemId) { return mailStore.items.get(itemId); },
})(function markItemJunkNotJunkFromReadingPane(itemId, actionSource, instrumentationContexts, state) {
    var item = state.item;
    var isJunkFolder = doesFolderIdEqualName(item.ParentFolderId.Id, 'junkemail');
    markItemsJunkNotJunkBasedOnItemIds([itemId], !isJunkFolder /* isJunkValueToSet*/, actionSource, instrumentationContexts, function () {
        var itemContexts = createItemContextsForDeleteStoreUpdate([itemId]);
        // Dispatch action to update the store state
        deleteItemsStoreUpdate(itemContexts, item.ParentFolderId.Id);
    });
});
//# sourceMappingURL=markItemJunkNotJunkFromReadingPane.js.map